import { TournamentTableDto } from "../../types/stats";
import { FCRodinaTable } from "../Table";
import { TableTeamTitle } from "../Table/TeamTitle";
import { getStaticUrl } from "../../utils";

interface TournamentTableProps {
    data: TournamentTableDto;
    columns?: string[];
    noLogos?: boolean;
    rowClass?: string;
}

export const TournamentTableMini: React.FC<TournamentTableProps> = ({
    data,
    columns = ['matchesPlayed', 'points'],
    noLogos,
    rowClass,
}) => {
    const dataColumns = [
        { title: '#', dataIndex: 'position', key: 'position' },
        { title: 'Команда', dataIndex: 'teamName', key: 'teamName', left: true },
    ];

    columns.forEach((column) => {
        if (column === 'matchesPlayed') {
            dataColumns.push({ title: 'И', dataIndex: 'matchesPlayed', key: 'matchesPlayed' });
        } else if (column === 'points') {
            dataColumns.push({ title: 'О', dataIndex: 'points', key: 'points' });
        }
    });

    let highlightRows: Set<number> = new Set();

    const dataItems = data?.map((item, index) => {
        if ([3, 135, 204, 724].includes(item.teamId)) {
            highlightRows.add(index)
        }
        return dataColumns.map((column) => {
            const value = item[column.dataIndex];
            if (column.dataIndex === 'teamName') {
                return {
                    key: column.key,
                    value: (
                        <TableTeamTitle logoUrl={!noLogos ? getStaticUrl(item.teamLogo) : ''} name={value} />
                    )
                }
            }
            return {
                key: column.key,
                value
            }
        });
    });

    return (
        <div className="rounded-xl overflow-hidden">
            <FCRodinaTable
                columns={dataColumns}
                data={dataItems}
                highlightRows={highlightRows}
                rowClass={"text-lg sm:text-xl " + rowClass}
            />
        </div>
    );
}

